import { render, staticRenderFns } from "./AddressProviderSwitch.vue?vue&type=template&id=76fc7b8d&scoped=true"
import script from "./AddressProviderSwitch.vue?vue&type=script&lang=ts"
export * from "./AddressProviderSwitch.vue?vue&type=script&lang=ts"
import style0 from "./AddressProviderSwitch.vue?vue&type=style&index=0&id=76fc7b8d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fc7b8d",
  null
  
)

export default component.exports